import useModal from '@fipnooone/react-modal';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Api, Code } from '@.api';
import { Auth } from '@/Services';

import { BrandActionConfirmModal } from '../ui/BrandActionConfirmModal';

export const useRestoreBrand = () => {
    const auth = Auth.Use();

    const [modal, modalControls] = useModal();

    const navigate = useNavigate();

    const handleRestore = useCallback(
        (brandId?: number) => {
            if (!brandId) {
                throw new Error('Brand id is required');
            }

            const createArchiveAction = (withProducts: boolean) => async () => {
                const response = await Api.brands().restore(brandId, withProducts);

                if (response.code !== Code.Success) {
                    alert(response.message);
                }

                modalControls.close();

                navigate(0);
            };

            const getBrandPreviewProducts = async (brandId: number) => {
                const response = await Api.brands().getRestorePreviewProducts(brandId);

                if (response.code === Code.Success) {
                    return response.data.products;
                }

                return [];
            };

            modalControls.set(
                <BrandActionConfirmModal
                    brandId={brandId}
                    title="Are you sure you want to restore the brand?"
                    confirmBrandText="Restore only brand"
                    confirmPartialText="Restore brand and all products"
                    actionOnlyBrand={createArchiveAction(false)}
                    actionBrandWithProducts={createArchiveAction(true)}
                    getPreviewProducts={getBrandPreviewProducts}
                    close={() => modalControls.close()}
                />
            );
        },
        [modalControls, navigate]
    );

    return {
        modal,
        auth,
        handleRestore,
    };
};
